import Table from 'components/Display/Table/Table'
import Page from 'components/Page/Page'
import tableActions from 'constants/tableActions'
import useFormMeterReadingLogic from 'logic/MetersReading/useFormMeterReadingLogic'
import useMetersReading from 'logic/MetersReading/useMetersReading'
import React from 'react'
import {
    useCreateMeterReadingMutation,
    useDeleteMeterReadingMutation,
    useGetMeterReadingsQuery,
    useEditMeterReadingMutation,
    useGetMeterReadingQuery,
} from 'store/Store'
import ExportMeterReadingsAction from 'components/Control/ActionMenuItem/ExportMeterReadingsAction'

const costumeTableHeaderActions = [
    {
        ActionComponent: ExportMeterReadingsAction,
        showOn: ['small', 'medium', 'large'],
    },
]

const MetersReading = () => {
    return (
        <Page>
            <Table
                itemName="meter_reading"
                paginationType="external"
                allowExpanded
                allowCreate
                allowEdit
                useEditMutation={useEditMeterReadingMutation}
                useGetQuery={useGetMeterReadingsQuery}
                useGetByIdQuery={useGetMeterReadingQuery}
                useCreateMutation={useCreateMeterReadingMutation}
                useDeleteMutation={useDeleteMeterReadingMutation}
                useModal={useMetersReading}
                tableActions={tableActions.meterReadingTableActions}
                useFormLogic={useFormMeterReadingLogic}
                costumeTableHeaderActions={costumeTableHeaderActions}
            />
        </Page>
    )
}

export default MetersReading
